<style>
.editor {
  max-height: 300px;
  overflow-y: auto;
  min-height: 20px;
}
</style>
<template>
  <div>
    <div v-if="mode === 'editor'">
      <div
        ref="editor"
        v-bind:class="{
          'demo__customScrollbar--brand': !noScroll,
          'demo__mobdoc--noscroll': noScroll,
        }"
        class="demo__padding--0 demo__font--16 editor"
      ></div>
      <slot></slot>
    </div>
    <div
      :id="idCopy || undefined"
      v-else-if="validMobiledoc"
      class="demo__mobiledoc-inner-styles"
    >
      <div v-if="!justString" v-html="rendered"></div>

      <div v-else>
        {{ renderedText }}
      </div>
    </div>
  </div>
</template>

<script>
import commonMobiledocHooks from "./mixins/commonMobiledocHooks";

export default {
  mixins: [commonMobiledocHooks],
  props: {
    uuid: {
      type: String,
      required: false,
    },
    mode: {
      type: String,
      required: false,
    },
    mobiledoc: {
      required: false,
      type: [Object, String],
      default: () => {
        return {};
      },
    },
    idCopy: {
      required: false,
      default: undefined,
    },
    placeholder: {
      required: false,
      default: false,
    },
    noScroll: {
      required: false,
      default: false,
    },
    justString: {
      required: false,
      default: false,
    },
    scrollCon: {
      required: false,
      default: false,
    },
    superFix: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.mode === "editor") {
      if (this.superFix) {
        this.initEditor();
      } else {
        this.$nextTick(() => {
          this.initEditor();
        });
      }
    }
  },
};
</script>
